import { Injectable, inject } from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {catchError, map, switchMap} from 'rxjs/operators';
import {of} from 'rxjs';
import {LoaderService} from '@app/services/loader.service';
import {IndustriesService} from '@app/services/industries.service';
import {IIndustryState} from '@app/stores/industries/industries.state';
import {
  IndustriesList,
  IndustriesListSuccess,
  IndustriesListError,
  IndustryCreate,
  IndustryCreateSuccess,
  IndustryCreateError,
  IndustryUpdate,
  IndustryUpdateSuccess,
  IndustryUpdateError,
  IndustryDelete,
  IndustryDeleteSuccess,
  IndustryDeleteError
} from '@app/stores/industries/industries.actions';

@Injectable()
export class IndustriesEffects {
  private _actions$ = inject(Actions);
  private _store = inject<Store<IIndustryState>>(Store);
  private industriesService = inject(IndustriesService);
  private loaderService = inject(LoaderService);


  industriesList$ = createEffect(() => this._actions$.pipe(
    ofType(IndustriesList),
    switchMap((action) => {
      this.loaderService.show();
      return this.industriesService.getIndustries(action.params).pipe(
        map((resp: any) => {
          if (resp.success) {
            this.loaderService.hide();
            return IndustriesListSuccess({paginatedIndustries: resp.data});
          }
          this.loaderService.hide(true);
          return IndustriesListError({error: this.loaderService.getErrorMessage(resp)});
        }),
        catchError(error => {
          this.loaderService.hide(true);
          return of(IndustriesListError({error: this.loaderService.getErrorMessage(error)}));
        })
      );
    })
  ));

  industryCreate$ = createEffect(() => this._actions$.pipe(
    ofType(IndustryCreate),
    switchMap((action) => {
      this.loaderService.show();
      return this.industriesService.createIndustry(action.industry).pipe(
        map((resp: any) => {
          if (resp.success) {
            this.loaderService.hide();
            return IndustryCreateSuccess();
          }
          this.loaderService.hide(true);
          return IndustryCreateError({error: this.loaderService.getErrorMessage(resp)});
        }),
        catchError(error => {
          this.loaderService.hide(true);
          return of(IndustryCreateError({error: this.loaderService.getErrorMessage(error)}));
        })
      );
    })
  ));

  industryUpdate$ = createEffect(() => this._actions$.pipe(
    ofType(IndustryUpdate),
    switchMap((action) => {
      this.loaderService.show();
      return this.industriesService.updateIndustry(action.industryId, action.industry).pipe(
        map((resp: any) => {
          if (resp.success) {
            this.loaderService.hide();
            return IndustryUpdateSuccess();
          }
          this.loaderService.hide(true);
          return IndustryUpdateError({error: this.loaderService.getErrorMessage(resp)});
        }),
        catchError(error => {
          this.loaderService.hide(true);
          return of(IndustryUpdateError({error: this.loaderService.getErrorMessage(error)}));
        })
      );
    })
  ));

  industryDelete$ = createEffect(() => this._actions$.pipe(
    ofType(IndustryDelete),
    switchMap((action) => {
      this.loaderService.show();
      return this.industriesService.deleteIndustry(action.industryId).pipe(
        map((resp: any) => {
          if (resp.success) {
            this.loaderService.hide();
            return IndustryDeleteSuccess();
          }
          this.loaderService.hide(true);
          return IndustryDeleteError({error: this.loaderService.getErrorMessage(resp)});
        }),
        catchError(error => {
          this.loaderService.hide(true);
          return of(IndustryDeleteError({error: this.loaderService.getErrorMessage(error)}));
        })
      );
    })
  ));
}
